module.exports = __webpack_public_path__ + "img/flwqdxanyfx.3a62c4a1.png";